import { getBrandName } from "@/lib/brand";
import { useT } from "@/lib/i18n";
import { legalLinkLanguage, legalLinks } from "@/lib/legal";
import { useLanguage } from "@/lib/language";
import { getSupportUrl } from "@/lib/support";
import { LanguageSelect } from "./language-select";

export function SiteFooter() {
  const language = useLanguage();
  const t = useT();
  const links = [
    { id: "terms", label: t("common.footer_terms"), href: legalLinks.terms(language) },
    { id: "privacy", label: t("common.footer_privacy"), href: legalLinks.privacy(language) },
    { id: "wallet", label: t("legal.wallet"), href: legalLinks.wallet(language) },
    { id: "support", label: t("common.footer_support"), href: getSupportUrl() }
  ].filter((link): link is { id: string; label: string; href: string } => Boolean(link.href));

  return (
    <footer className="site-footer">
      <span>{getBrandName()} · {new Date().getFullYear()}</span>
      <nav aria-label={t("common.footer_nav")}>{links.map((link) => <a key={link.id} href={link.href} hrefLang={legalLinkLanguage(link.href, language)} target="_blank" rel="noopener noreferrer">{link.label}</a>)}</nav>
      <LanguageSelect />
    </footer>
  );
}
